import { TableBody } from '@client/toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpanableTableWraper } from '../../components/expanable-table-wraper';
import { NetYieldBuildingDetailReadModel } from '@client/api';
import { BuildingRow } from '.';
import dayjs from 'dayjs';

interface TableProps {
  data: NetYieldBuildingDetailReadModel[];
  loading: boolean;
  onSelected: (ids: Set<string>) => void;
  startDate?: string;
  endDate?: string;
}

export const Table: React.FC<TableProps> = ({ data, loading, onSelected, startDate, endDate }) => {
  const { t } = useTranslation('reporting');

  const columns = [
    { key: 'name', label: t('netYield.building') },
    { key: 'operatingCost', label: t('netYield.operationalCost') },
    { key: 'netIncomeAmount', label: t('netYield.netIncome') },
    { key: 'propertyValue', label: t('netYield.propertyValue') },
    { key: 'netYieldThisPeriod', label: t('netYield.netYieldYear', { year: dayjs(endDate).year() }) },
    {
      key: 'netYieldLastPeriod',
      label: t('netYield.netYieldYear', { year: dayjs(endDate).subtract(1, 'year').year() }),
    },
    { key: 'percentageChangesLast12Months', label: t('netYield.netYieldLastTwelveMonths') },
  ];
  return (
    <ExpanableTableWraper
      columns={columns}
      data={data}
      loading={loading}
      onSelected={onSelected}
      renderBody={(data, selectedRows, expandedRows, handleToggleSelect, handleKeyDownSelect) => (
        <TableBody>
          {data.map((building) => (
            <React.Fragment key={building.spaceId}>
              <BuildingRow
                building={building}
                selectedRows={selectedRows}
                handleToggleSelect={handleToggleSelect}
                handleKeyDownSelect={handleKeyDownSelect}
                startDate={startDate}
                endDate={endDate}
              />
            </React.Fragment>
          ))}
        </TableBody>
      )}
    />
  );
};
